import { Button } from "@mui/material";
import colors from "assets/theme/base/colors";
import React from "react";

const SubmitButton = ({ btnText, type, background, color, hoverBackground, onClick, width }) => {
  const { white, info } = colors;

  return (
    <Button
      variant="contained"
      size="medium"
      type={type}
      onClick={onClick}
      sx={{
        gap: "10px",
        margin: "20px 0px",
        minWidth: "129px",
        width: `${width}`,
        color: `${color ? color : white.main} !important`,
        backgroundColor: `${background ? background : info.main} !important`,
        "&:hover": {
          backgroundColor: `${hoverBackground ? hoverBackground : info.main} !important`,
        },
        "&:focus:not(:hover)": {
          backgroundColor: `${hoverBackground ? hoverBackground : info.main} !important`,
        },
      }}
    >
      {btnText}
    </Button>
  );
};

export default SubmitButton;
